import ProviderCommonApi from '../../../API/provider/common-api';
import GalaApi from '../../../API/provider/gala-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ImportExcelButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { PROVIDERS, TYPE_BUTTONS } from '../../../constans';
import { divideToSubarray } from '../../../utils';

const GalaPage = ({ ...props }) => {

  const loadProducts = async () => {
    await GalaApi.loadProducts()
  };

  const providerId = PROVIDERS.GALA.id;

  const importData = async (data, skladName = "msk") => {
    let trueData = data
      .map((item) => ({
        sku: item['Код'] || item['Артикул'] || '',
        name: (item['Наименование товара'] || item['Номенклатура'] || '').trim(),
        brand: item['Бренд'],
        category: item['Категория'],
        cost: item['Цена'] || item['Цена 7'],
        price: item['Цена'] || item['Цена 7'],
        min_opt: item['Мин. парт.'] || item['Минимальная партия'],
        stocks: item['Сток'] || item['МСК Белый Раст НОВЫЙ'] || item['ЕКБ Логопарк НОВЫЙ'],
        barcode: item['Штрихкод'] || '',
        image: item['Ссылка на фото'] || '',

        //image: item['Изображение 1'],
        // url: item['Ссылка на товар'],
      }))
      .filter((item) => item.sku !== '' && item.name !== '' && item.stocks !== null && parseInt(item.stocks) >= 10);

    trueData = trueData.map((item) => ({
      ...item,
    }));

    console.log(trueData);

    const subarray = divideToSubarray(trueData, 2000);
    if (subarray.length > 0) {
      for (let j = 0; j < subarray.length; j++) {
        await GalaApi.addStocks({ data: { data: subarray[j], skladName } })
          .then(() => console.log('load', j * 2000, '-', (j + 1) * 2000))
          .catch((err) => console.log(err));
      }
    }
  };

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock>
            <Column style={{ marginBottom: '15px' }}>
              <Row>
                <Button type={TYPE_BUTTONS.BLUE} onClick={loadProducts} style={{ marginRight: '15px' }}>
                  Выгрузить весь товар
                </Button>
                <ImportExcelButton onChange={d => importData(d, "msk")} style={{ marginRight: '15px' }}>Подгрузить остатки Мск</ImportExcelButton>
                <ImportExcelButton onChange={d => importData(d, "ekb")}>Подгрузить остатки Екб</ImportExcelButton>

              </Row>
              <Row style={{ alignItems: 'flex-start', marginTop: '10px' }}>
                <Button type={TYPE_BUTTONS.RED} onClick={() => ProviderCommonApi.nullStocks({ data: { providerId } })} style={{ marginRight: '15px' }}>
                  Обнулить остатки
                </Button>
              </Row>

              <ProviderUpdateStatusBlock providerId={providerId} />
            </Column>
          </WhiteBlock>
          <ProviderDasboardContentWhiteBlock providerId={providerId} />
        </Row>
        <ProviderProductsTable providerId={providerId} isMinPackage={true} isCityStocks={true} />
      </Content>
    </>
  );
};

export default GalaPage;
